var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('base-loading'):_c('div',{staticClass:"pa-8 d-flex fill-width flex-column align-center justify-center"},[_c('section',{staticClass:"d-flex flex-column align-center justify-center"},[_c('p',[_vm._v("Auth completed!")])])])}
var staticRenderFns = []

export { render, staticRenderFns }